export const langList = [
    {
      langName: "English",
      langImgSrc: "/assets/media/flags/226-united-states.svg",
      local: "en_us"
    },
    {
      langName: "Українська",
      langImgSrc: "/assets/media/flags/ukr.png",
      local: "uk_ua"
    },
    {
      langName: "Русский",
      langImgSrc: "/assets/media/flags/rus.png",
      local: "ru_ru"
    },
]